import { PORTAL_PROXY_TOKEN } from '../settings';
import { type ApiMediaUploadCredentials, type JsmErrorResponseDto } from '../types';
import { JsmClient } from '../utilities';
import { mapJsmErrorResponseDtoToFormError } from './mapJsmErrorResponseDtoToFormError';

export const createApiMediaUploadCredentials = async (portalBaseUrl: string): Promise<ApiMediaUploadCredentials> => {
  const jsmClient = new JsmClient(portalBaseUrl);
  const url = '/media/credentials/upload';

  try {
    const response = await jsmClient.get(url, {
      // set credentials option to 'include' to store 'atlassian.xsrf.token' cookie
      credentials: 'include',
      // to avoid preflight request send proxy token in Content-Language header - portal proxy will fix it
      headers: { 'Content-Language': PORTAL_PROXY_TOKEN },
    });
    return response as ApiMediaUploadCredentials;
  } catch (error: any) {
    console.error('createMediaUploadCredentials: JSM error:', JSON.parse(JSON.stringify(error)));
    const jsmError = error.responseBody as JsmErrorResponseDto;
    throw mapJsmErrorResponseDtoToFormError(jsmError);
  }
};
